import { Outlet, useLocation, Link } from 'react-router-dom';
import { Home, Calendar, User } from 'lucide-react';
import clsx from 'clsx';

export default function Layout() {
  const location = useLocation();

  const navItems = [
    {
      path: '/today',
      label: 'Hoje',
      icon: Home,
    },
    {
      path: '/calendar',
      label: 'Agenda',
      icon: Calendar,
    },
    {
      path: '/profile',
      label: 'Perfil',
      icon: User,
    },
  ];

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Main Content */}
      <main className="flex-1 overflow-y-auto pb-20 custom-scrollbar">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-bottom">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={clsx(
                  'flex flex-col items-center justify-center flex-1 h-full tap-target',
                  'transition-colors duration-150',
                  isActive
                    ? 'text-primary-600'
                    : 'text-gray-500 hover:text-gray-700 active:text-gray-900'
                )}
              >
                <Icon className="w-6 h-6 mb-1" />
                <span className="text-xs font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
